require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-idb-invest-policy-review-update-csos-recommendations.json") })
        }
      }, "path---en-us-update-idb-invest-policy-review-update-csos-recommendations");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-idb-invest-policy-review-update-csos-recommendations!./.cache/json/en-us-update-idb-invest-policy-review-update-csos-recommendations.json
// module id = 749
// module chunks = 231608221292675